import type { Plugin } from 'vue';
import VueClickAway from 'vue3-click-away';
import '@vuepic/vue-datepicker/dist/main.css';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(VueClickAway as unknown as Plugin);
});
